import React from "react";
import { Route, Redirect } from "react-router-dom";

const AuthNoLayoutRoute = ({ component: Component, ...rest }) => {
  let user = rest.state.isUserAuthenticated;
  let temp = rest.state.isValid;

  return (
    <Route
      {...rest}
      render={(props) =>
        !user && !temp ? (
          <Component {...props} {...rest} key={rest.location?.key} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default AuthNoLayoutRoute;
